{
  "common.loading": "Cargando...",
  "common.error": "Algo sali\u00f3 mal",
  "common.retry": "Reintentar",
  "common.cancel": "Cancelar",
  "common.save": "Guardar",
  "common.delete": "Eliminar",
  "common.edit": "Editar",
  "common.post": "Publicar",
  "common.follow": "Seguir",
  "common.following": "Siguiendo",
  "common.followers": "seguidores",
  "common.likes": "me gusta",
  "common.posts": "publicaciones",
  "common.signOut": "Cerrar sesi\u00f3n",

  "feed.forYou": "Para Ti",
  "feed.following": "Siguiendo",
  "feed.whatsOnYourMind": "\u00bfQu\u00e9 est\u00e1s pensando?",
  "feed.noPostsYet": "A\u00fan no hay publicaciones",
  "feed.trending": "Tendencia en Scroll",

  "compose.placeholder": "\u00bfQu\u00e9 est\u00e1 pasando?",
  "compose.posting": "Publicando...",
  "compose.charLimit": "{count}/{max}",

  "profile.editProfile": "Editar perfil",
  "profile.message": "Mensaje",
  "profile.noPostsYet": "A\u00fan no hay publicaciones",
  "profile.noVideosYet": "A\u00fan no hay videos",
  "profile.posts": "Publicaciones",
  "profile.videos": "Videos",

  "bookmarks.title": "Marcadores",
  "bookmarks.empty": "A\u00fan no hay marcadores",
  "bookmarks.emptyHint": "Guarda publicaciones para despu\u00e9s tocando el icono de marcador",

  "activity.title": "Actividad",
  "activity.empty": "A\u00fan no hay actividad",
  "activity.emptyHint": "Cuando alguien le d\u00e9 me gusta, responda o te siga, aparecer\u00e1 aqu\u00ed.",
  "activity.emptyFiltered": "A\u00fan no hay actividad en esta categor\u00eda",
  "activity.today": "Hoy",
  "activity.thisWeek": "Esta semana",
  "activity.earlier": "Anterior",
  "activity.filter.all": "Todo",
  "activity.filter.follows": "Seguidores",
  "activity.filter.replies": "Respuestas",
  "activity.filter.mentions": "Menciones",
  "activity.filter.reposts": "Republicaciones",
  "activity.followedYou": "empez\u00f3 a seguirte",
  "activity.likedYourPost": "le gust\u00f3 tu publicaci\u00f3n",
  "activity.repliedToYourPost": "respondi\u00f3 a tu publicaci\u00f3n",
  "activity.mentionedYou": "te mencion\u00f3",
  "activity.repostedYourPost": "republic\u00f3 tu publicaci\u00f3n",
  "activity.tippedYou": "te envi\u00f3 una propina",

  "settings.mutedWords": "Palabras silenciadas",
  "settings.mutedWordsHint": "Las publicaciones con palabras silenciadas se ocultar\u00e1n",
  "settings.addWordPlaceholder": "A\u00f1adir una palabra o frase...",
  "settings.noMutedWords": "A\u00fan no hay palabras silenciadas",
  "settings.moderation": "Moderaci\u00f3n de contenido",
  "settings.accessibility": "Accesibilidad",

  "onboarding.welcome": "Bienvenido a Scroll",
  "onboarding.selectInterests": "Selecciona tus intereses",
  "onboarding.suggestedFollows": "Creadores sugeridos",
  "onboarding.done": "\u00a1Todo listo!",
  "onboarding.skip": "Omitir",
  "onboarding.next": "Siguiente",
  "onboarding.finish": "Empezar a navegar",

  "error.somethingWentWrong": "Algo sali\u00f3 mal",
  "error.unexpectedError": "Ocurri\u00f3 un error inesperado",
  "error.tryAgain": "Reintentar"
}
